import React from "react";

export function ButtonGroup({ children }: any) {
  return <div className="gui-button-group">{children}</div>;
}

export default ButtonGroup;
